import { getApiHost } from "@linkfluence/konf";
import { App } from "@linkfluence/models/app";
import { Platform } from "@linkfluence/models/platform";
import { cleanUrl } from "@tootools/http-utils";
import { getUrl } from "@tootools/query-string";
import { PicturesUsage } from "@radarly/models/picture";
import { BlockedAuthors, Project, WeiboStatus } from "@radarly/models/project";
import { CreateProjectUser, SearchUser } from "@radarly/models/user";
import { RadarlyAPI } from "./base";

const getPlaceHolder = (platform: Platform, size: string) => {
  return encodeURI(
    ["/public/images/raw/avatars/avatar_", platform, "_", size, ".png"].join("")
  );
};

export function getFaviconUrl(url: string, size: string, platform: Platform) {
  return getUrl(
    "https://magnum.linkfluence.com/photo?url=:url&size=:size&placeholder=:placeholder",
    {
      url: cleanUrl(url),
      size,
      placeholder: getPlaceHolder(platform, size),
    }
  );
}

export class ProjectAPI extends RadarlyAPI {
  public async contactProjectManager(
    project: number,
    subject: string,
    text: string
  ) {
    return await this.post<void>(`/projects/${project}/contact-manager.json`, {
      subject,
      text,
    });
  }
  public async getProject(project: number) {
    return await this.get<Project>(`/projects/${project}.json`);
  }

  public generateProjectPictureUrl(project: number, picture: number) {
    return `${getApiHost(
      App.Radarly
    )}/2.0/projects/${project}/pictures/${picture}`;
  }
  public async getProjectPicturesUsage(project: number) {
    return await this.get<PicturesUsage>(
      `/projects/${project}/pictures/usage.json`
    );
  }

  public async getProjectBlockedAuthors(project: number) {
    return await this.get<BlockedAuthors>(`/projects/${project}/blocked.json`);
  }

  public async removeUser(project: number, userId: number) {
    return await this.delete<void>(
      `/projects/${project}/roles/users/${userId}.json`
    );
  }
  public async removeUsers(project: number, usersId: number[]) {
    return await Promise.allSettled(
      usersId.map((userId) => this.removeUser(project, userId))
    );
  }
  public async createProjectUser(project: number, user: CreateProjectUser) {
    return await this.post<{ user: Omit<SearchUser, "workspaces"> }>(
      `/projects/${project}/users.json`,
      user,
      true
    );
  }


  public async getWeiboStatus() {
    return await this.get<WeiboStatus>(`/freeze-weibo-queries`);
  }
}
